import { createLogger } from "@/logger";

const log = createLogger("storage");

/**
 * Best-effort request for persistent (eviction-exempt) storage. Chromium/Edge evict origin storage
 * — including the store snapshot and bootstrap registry — under disk pressure unless the origin holds the
 * persistent grant; losing that store empties the channel list (WEB-2152). Feature-detected and
 * never fatal.
 */
export async function requestPersistentStorage(): Promise<void> {
  if (typeof navigator === "undefined" || typeof navigator.storage?.persist !== "function") return;
  try {
    const granted = await navigator.storage.persist();
    log.info("[Storage] navigator.storage.persist() result", { granted });
  } catch (error) {
    log.warn("[Storage] navigator.storage.persist() failed", { error });
  }
}
